import './PageModule.less';

import clsx from 'clsx';
import React from 'react';

export default function PageModule({
    className,
    title,
    subtitle,
    description,
    badge,
    link,
    disabled,
    children,
    onClick
}) {
    const active = !!onClick;
    return (
        <div className={clsx('page-module', className)}>
            <h1 className={clsx({ active })} onClick={disabled ? null : onClick}>
                {title}
                {link ? <button disabled={disabled}>{link}</button> : null}
                {badge ? <div className="badge">{badge}</div> : null}
            </h1>
            {subtitle ? <h3>{subtitle}</h3> : null}
            {description ? <p>{description}</p> : null}
            {children}
        </div>
    );
}
